<div class="homeContainer textColor">
	<img class="hrLogo" src="../assets/images/hr-logo-white.png" />
	<h1 class="mat-display-2">HawkRidge Portal</h1>
	<h1 class="mat-display-3">Welcome...!</h1>
</div>
